"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { TableSectionContext } from "./table.js";
const value = { parent: "TableBody", parentColor: undefined };
export const TableBody = React.forwardRef(function TableBody(_a, ref) {
    var { children, color = "primary-25" } = _a, props = __rest(_a, ["children", "color"]);
    return (_jsx("tbody", Object.assign({ ref: ref }, props, { children: _jsx(TableSectionContext.Provider, { value: Object.assign(Object.assign({}, value), { parentColor: color }), children: children }) })));
});
export default TableBody;
//# sourceMappingURL=table-body.js.map